// DatabaseAboutEditorForm.jsx

import React from 'react';

// Components
import CreateTypeFields from 'components/addmodal/sections/createtype/CreateTypeFields';

/**
 * DatabaseAboutEditorForm
 *
 * Shared database metadata form for modal and Studio embedded editors.
 *
 * @returns {ReactNode} The rendered component.
 */
const DatabaseAboutEditorForm = React.memo((props) => {

  // ----- RENDER ----- //

  return (
  <CreateTypeFields {...props} />
  );
});

// Dev Tools
DatabaseAboutEditorForm.displayName = 'DatabaseAboutEditorForm';

export default DatabaseAboutEditorForm;
